import React from 'react';

const DEFAULT_PLACEHOLDER = 'data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2210%22 height=%226%22 viewBox=%220 0 10 6%22%3E%3Crect width=%2210%22 height=%226%22 fill=%22%23f6f6f7%22/%3E%3C/svg%3E';

export default function ProgressiveImg({ src, alt = '', className = '', style = {}, placeholder, ...rest }) {
  const ph = placeholder || DEFAULT_PLACEHOLDER;
  const [loaded, setLoaded] = React.useState(false);
  const [currentSrc, setCurrentSrc] = React.useState(ph);

  React.useEffect(() => {
    let cancelled = false;
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => {
      if (!cancelled) {
        setLoaded(true);
        setCurrentSrc(src);
      }
    };
    img.onerror = () => {
      if (!cancelled) {
        setLoaded(true);
        // keep placeholder on error
      }
    };
    img.src = src;
    return () => { cancelled = true; };
  }, [src]);

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      style={{
        ...style,
        transition: 'opacity 300ms ease',
        opacity: loaded ? 1 : 0.85
      }}
      loading="lazy"
      decoding="async"
      {...rest}
    />
  );
}


